/**
 * Crée une base de formulaire Alpine à composer
 *
 */
export default function createBaseForm(formName = null, storeName = null, sfFieldNameSuffix = null, params= {}) {
    return {
        // Définition du form
        formId: null,
        formName : null,
        store: null,
        debug: true,
        displayErrors : false,

        init() {
            this.log('Form init');

            // Deduire les propriétés des attributs dates de l'element cible ou des paramètres fournis
            this.formName =  formName ?? this.$el.name
            this.formId = this.$el.id ?? this.formName;

            if (!this.formId) {
                throw new Error('No explicit formId found and no formName to fallback on: it should be passed as a data attribute or a form config parameter');
            }

            // Récupérer le store associé au formulaire
            const calcStoreName = storeName ?? this.$el.dataset.storeName ?? this.formName;
            this.store = this.$store?.[calcStoreName];

            if (!this.store) {
                throw new Error(`Store "${calcStoreName}" not found`);
            }
            if (sfFieldNameSuffix) {
                this.sfFieldNameSuffix = sfFieldNameSuffix;
            } else  this.sfFieldNameSuffix = this.store.sfFieldNameSuffix;

            this.log('Init form  with formId ' + this.formId + ' and formName ' + this.formName
                + 'suffix :' + this.sfFieldNameSuffix );
            this.checkServerErrors();
            this.log('Form init done');
        },

        // Récupération des erreurs renvoyés par le submit au serveur
        // NB : le fait de passer par root plutot que de chercher
        // directement dans le DOM  prémunit contre des erreurs possibles si le HTML du formulaire
        // est rechargé en ajax au submit par exemple
        checkServerErrors() {
            this.log('checkServerErrors');
            const el = this.$root.querySelector('.form-errors');
            if (!el) return;
            this.log('form-errors : ' + el.textContent, el);
            const errors = el ? JSON.parse(el.textContent) : {}
            this.store.initServerErrors(errors)
        },

        reset() {
            this.form = {};
            this.errors = {};
            this.definitions = {};
        },

        log(...args) {
            if (this.debug) {
                console.log(...args)
            }
        },

        get data() {
            return this.store?.data ?? {};
        },

        get errors() {
            return this.store?.errors ?? {};
        },

        /**
         * Pour scroller jusqu'au premier champ avec erreur
         */
        scrollToFirstError() {

            const firstFieldWithError = this.store.findFirstFieldWithError();
            if (firstFieldWithError) {

                const el = document.getElementsByName(firstFieldWithError)[0]

                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
                    el.focus()
                }
            }
        },
        beforeSubmit() {

        },
        onSubmit(event) {

            console.log('onSubmit');
            // Vérifie au niveau du store si le formulaire est valide avant de submit réellement
            this.store.validateAll()
            if (!this.store.isFormValid()) {
                console.log('Form is not valid');
                this.store.markAllTouched()
                this.store.submitFailed = true
                this.scrollToFirstError()
                return;
            }
            this.beforeSubmit()
            // Vérifie si la méthode submit existe si oui l'appelle sinon post le formulaire
            if (this.submit) {
                return this.submit(event);
            }
            return this.defaultSubmit(event);
        },

        defaultSubmit(event) {
            event.target.submit();
        },

        canSubmit() {
            return !this.store?.hasPendingServerValidation();
        },


        showErrorSummary(){
            console.log('showErrorSummary');
            return this.store.displayErrorSummary;
        },

        hasGlobalErrors() {
            return this.store.hasGlobalErrors;
        },

        hasNonGlobalErrors() {
            return this.store.hasNonGlobalErrors;
        },

        globalErrors() {
            return this.store.globalErrors;
        }

    }
}
